module.exports = __webpack_public_path__ + "static/media/vip_interest_icon.41fe5a6a.svg";